<div class="col-12 component-input-header">
  <div class="row">
    <div class="col-2 p-0 logo">
      <img id="img-symbol" class="imgMiniBook " src="{{ image }}"
        onError="this.src='./assets/images/symbols/INDISPONIVEL.PNG';">
    </div>
    <div class="col-10 pl-0 info">
      <div class="row">
        <div class="col-5 p-0 input">
          <app-auto-complete class="auto-complete" [placeHolderSetter]="''" [symbolAutoComplete]="symbolAutoComplete"
            [reset]="reset" (onsymbolChanged)="selectAsset($event)" [autoSizeActive]="true" [autoFocus]="true"
            [focusDelay]="focusDelay">
          </app-auto-complete>
        </div>
        <div class="col-7">
          <div class="row">
            <div class="col-7 price" *ngIf="showLastTrade">{{ lastTrade ? lastTrade : '-' }}</div>
            <div class="col-5 p-0 variation">
              <div id="variation" *ngIf="!showVariation && !dateLastNegotiation">
                {{ hourLastTrade ? hourLastTrade : timeUpdate }}</div>
              <div id="variation" class="date" *ngIf="!showVariation && dateLastNegotiation">
                {{ dateLastNegotiation }}</div>
              <div id="variation" class="percent" *ngIf="showVariation"
                [ngClass]="{ 'low' : showVariation && variation < 0, 'high' : showVariation && variation > 0}">
                {{variation > 0 ? '+' : ''}} {{variation ? (variation/100 | percent:'1.2':'pt') : '' }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 p-0 input" [ngClass]="{'col-12': hiddenInvalid}">
          <span id="company" class="col-12 company" #tooltipMin="matTooltip" matTooltipPosition="below"
            matTooltip="{{ company }}" *ngIf="!hiddenInvalid">{{ company ? company : 'Infome um ativo válido' }}</span>
          <span id="invalid-asset" class="invalid" *ngIf="hiddenInvalid">{{ msgInvalidAsset }}</span>
        </div>
        <div class="col-3 p-0 variation" [ngClass]="{ 'low' : coinVariation < 0, 'high' : coinVariation > 0}">
          <div *ngIf="showVariation && !hiddenInvalid">
            {{ coinVariation > 0 ? '+' : '' }} {{ coinVariation ? (coinVariation | number) : '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
